import React from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";

import { useAppDispatch } from "../../../../redux/store";
import { fetchSendPhone } from "../../../../redux/profile/settings/changePass/asyncActions";
import { addPhone, clearErrorMessage } from "../../../../redux/profile/settings/changePass/slice";
import { changePassSelector } from "../../../../redux/profile/settings/changePass/selectors";

import { Button, PhoneInput } from "../../../../components";
import { cleanPhone } from "../../../../utils";

import styles from "./PhoneForm.module.scss";

import { ValidMessages } from "../../../../resources/locale";
import { SubmitValueType } from "./types";

type PhoneFormProps = {
  handleSubmitForm?: () => void;
};

export const PhoneForm: React.FC<PhoneFormProps> = (props) => {
  const { handleSubmitForm } = props;
  const dispatch = useAppDispatch();
  const { isLoading, errorMessage } = useSelector(changePassSelector);

  const initialValues = {
    phone: "",
  };

  const validationSchema = Yup.object({
    phone: Yup.string()
      .min(18, ValidMessages.inputs.phone.NOT_FULL)
      .required(ValidMessages.inputs.phone.REQUIRED),
  });

  const handleSubmit = async (values: SubmitValueType) => {
    const phone = cleanPhone(values.phone);

    dispatch(addPhone(phone));
    const result = await dispatch(fetchSendPhone({ phone }));
    
    if (fetchSendPhone.fulfilled.match(result)) {
      handleSubmitForm && handleSubmitForm();
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnChange={true}
      validateOnBlur={true}
    >
      {(formik) => {

        return (
          <Form className={styles.form}>
            <div className={styles.formSection}>
              <PhoneInput name="phone" lable="Телефон" placeholder="+7 (___) ___-__-__" />
              <ErrorMessage
                component="div"
                className={styles.errorMessage}
                name="phone"
              />
              {errorMessage ? (
                <div className={styles.errorMessage}>
                  {errorMessage}
                </div>
              ) : null}
            </div>

            <Button
              type="submit"
              newStyles={styles.button}
              disabled={formik.isSubmitting || isLoading}
            >
              {isLoading ? "Отправка..." : "Отправить"}
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};
